<ng-container [formGroup]="formGroup">
  @if (maxxFeatureEnabled) {
    <div class="section mode-picker-section">
      <div class="mode-picker">
        <pdq-button
          variant="empty"
          label="Manual"
          [active]="!isMaxxAi"
          (onClick)="onModeChange(Mode.MANUAL)"></pdq-button>
        <pdq-button
          class="mode-picker__maxx"
          variant="empty"
          [active]="isMaxxAi"
          (onClick)="onModeChange(Mode.MAXX_AI)">
          <span class="mode-picker__maxx-label">
            MAXX AI
            <span class="maxx-ai-badge">AI</span>
          </span>
        </pdq-button>
      </div>
    </div>
  }

  <div class="section">
    <pdq-heading element="h5">Token for Shopify</pdq-heading>
    <div class="controls-wrapper">
      <pdq-link
        label="View detailed installation instructions"
        [external]="true"
        url="https://support.prettydamnquick.com/en/articles/8560867-adding-multiple-pdq-components"></pdq-link>
      <pdq-input
        [disabled]="true"
        [formControl]="formGroup.get('usageToken')"
        label="Copy & paste this into Shopify's Components by 'Gift unlock token'"
        [clipboard]="true"></pdq-input>
      <pdq-extension-preview-token [usageTokenControl]="formGroup.get('usageToken')"></pdq-extension-preview-token>
    </div>
  </div>

  <div class="section">
    <pdq-heading element="h5">General</pdq-heading>
    <div class="controls-wrapper">
      <pdq-input [formControl]="formGroup.get('internalName')" label="Internal Name"></pdq-input>
      <pdq-input [formControl]="formGroup.get('title')" label="Internal Description"></pdq-input>
      <pdq-radio-group label="Component placement" formControlName="placementMode">
        <pdq-radio-button
          [value]="PlacementMode.STANDALONE"
          text="Standalone"
          [checked]="formGroup.get('placementMode').value === PlacementMode.STANDALONE"></pdq-radio-button>
        <pdq-radio-button
          [value]="PlacementMode.LINKED"
          [checked]="formGroup.get('placementMode').value === PlacementMode.LINKED">
          <ng-template #customContent>
            <div class="linked-mode-radio-content">
              <p class="linked-mode-radio-content__title caption-medium-caps">Inside shipping method</p>
              <p class="linked-mode-radio-content__description body-12-regular">
                Go to your
                <pdq-link
                  [clickable]="true"
                  [external]="true"
                  size="small"
                  label="Online Store Editor"
                  [url]="shopService.ecommerceEditorUrl()"></pdq-link>
                to define which shipping method this extension shows up for
              </p>
            </div>
          </ng-template>
        </pdq-radio-button>
      </pdq-radio-group>

      @if (isMaxxAi) {
        <div class="offer-type-locked">
          <label class="offer-type-locked__label">Offer Type</label>
          <div class="offer-type-locked__field">
            <span class="offer-type-locked__value">Coupon</span>
            <span class="offer-type-locked__indicator">
              <pdq-icon icon="lock" size="smaller"></pdq-icon>
              Locked
            </span>
          </div>
        </div>
      } @else {
        <pdq-dropdown
          [formControl]="formGroup.get('settings.offerType')"
          title="Offer Type"
          [options]="offerTypeOptions"
          optionLabel="label"
          optionValue="value">
        </pdq-dropdown>
      }

      @if (
        !isMaxxAi &&
        (formGroup.get('settings.offerType').value === OfferType.PRODUCT ||
          formGroup.get('settings.offerType').value === OfferType.SELLING_PLAN_PRODUCT)
      ) {
        <pdq-checkbox
          [formControl]="formGroup.get('settings.productDetails.autoAddToCart')"
          label="Auto-Apply Gift If Product Is Free"
          labelSize="small">
        </pdq-checkbox>
        @if (formGroup.get('settings.productDetails.autoAddToCart')?.value) {
          <pdq-banner
            variant="attention"
            bannerTitle="Auto-Apply Mode"
            [closable]="false"
            content="Gift will be added to cart automatically. 'Gift Message' tab is disabled and only 'Single Gift' mode is available — a specific product and variant must be defined to auto-apply.">
          </pdq-banner>
        }
      }
    </div>
  </div>

  <div class="section">
    <pdq-heading element="h5">Display conditions</pdq-heading>
    <div class="controls-wrapper">
      <span>This Gift Unlock Will Only Appear If:</span>
      <pdq-rules-dynamic-form
        [formGroup]="formGroup"
        formArrayFieldName="displayRules"
        [rules]="displayRules | addCurrencyOption: shopCurrencySymbol"
        [entities]="displayRulesEntities"
        [shopCurrencySymbol]="shopCurrencySymbol"
        [versionWithOrOperator]="true"></pdq-rules-dynamic-form>
      @if (shouldShowKeepInCart) {
        <pdq-banner
          variant="attention"
          bannerTitle="Discount Protection"
          [closable]="false"
          content="When the reward's own discount lowers the cart total below the minimum cart value, the gift stays in the cart instead of being removed — so the discount can't disqualify the gift it just unlocked. Drops from other causes (like removing items) still remove the gift.">
        </pdq-banner>
        <pdq-radio-group
          formControlName="keepInCart"
          label="When a discount drops the cart below the minimum value"
          [preserveTextCase]="true">
          <pdq-radio-button
            [value]="true"
            [checked]="formGroup.get('keepInCart').value === true"
            text="Keep the gift in the cart"></pdq-radio-button>

          <pdq-radio-button
            [value]="false"
            [checked]="formGroup.get('keepInCart').value === false"
            text="Remove the gift"></pdq-radio-button>
        </pdq-radio-group>
      }
    </div>
  </div>
</ng-container>
